export default {
  CREATE: "create",
  UPDATE: "update",
  SHOW: "show",
  EDIT: "edit",
};
